import store from '@redux/store';
import { operations, selectors } from '@redux/index';

export const getTurnstileSiteKey = () =>
  String(import.meta.env.VITE_TURNSTILE_SITE_KEY ?? '')
    .trim()
    .replace(/^['"]|['"]$/g, '');

/** 1st invalid Turnstile attempt — refresh token and retry once. */
export const isRecaptchaVerificationError = (message?: string | null) => {
  if (!message) return false;
  const normalized = message.toLowerCase();
  return (
    normalized.includes('unable to verify turnstile')
    || normalized.includes('recaptcha request could not be verified')
  );
};

/** Member blocked after exceeding invalid Turnstile attempts. */
export const isRecaptchaBlockedError = (message?: string | null) => {
  if (!message) return false;
  return message
    .toLowerCase()
    .includes('blocked due to exceeding invalid attempts for recaptcha');
};

/** @deprecated use isRecaptchaBlockedError */
export const isRecaptchaRetryExceededError = isRecaptchaBlockedError;

export const RECAPTCHA_BLOCKED_POPUP_KEY = 'showRecaptchaBlockedPopup';

/** Persist lock flag and send user to the locked screen (popup first). */
export const redirectToLockedForRecaptcha = () => {
  try {
    const loggedInDetails = selectors.loggedInDetails(store.getState());
    store.dispatch(
      operations.dispatchLoggedInDetails({
        ...loggedInDetails,
        isLocked: true,
      })
    );
  } catch {
    // ignore store errors; still navigate
  }

  if (typeof window === 'undefined') return;

  sessionStorage.setItem(RECAPTCHA_BLOCKED_POPUP_KEY, '1');

  if (window.location.pathname !== '/locked') {
    window.location.assign('/locked');
  } else {
    window.location.reload();
  }
};

/** Call when any API returns a recaptcha-blocked payload (middleware or captcha endpoints). */
export const handleRecaptchaApiMessage = (message?: string | null): boolean => {
  if (!isRecaptchaBlockedError(message)) return false;
  redirectToLockedForRecaptcha();
  return true;
};
